import '@/lib/i18n';
import '@/lib/sentry';
import { PosthogProvider } from '@/components/providers/posthog';
import { RouterProvider } from '@/components/providers/router';
import { ThemeProvider } from '@/components/providers/theme';
import type { router } from '@/lib/router';

import { QueryProvider } from './components/providers/query';

import 'mapbox-gl/dist/mapbox-gl.css';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <PosthogProvider>
          <RouterProvider />
        </PosthogProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
